import ContentWrapper from "@/components/wrappers/ContentWrapper";
import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { skipInitialFormValues } from "@/utils/formUtils";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { URLQuery } from "@/utils/queryUtils";
import { Card, Flex, Radio } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { useFilterManualDebtAccountMovements } from "../../../../common/api/queries";
import BackNavigationArrow from "../../../../common/components/views/BackNavigationArrow";
import { EntityIdObject } from "../../../../common/types";
import { ManualDebtAccountMovementsReport } from "../../debtaccount/enums";
import { ManualDebtAccountMovementsFilterPageRequest } from "../../debtaccount/types";
import { DEFAULT_FILTER_MANUAL_DEBT_ACCOUNT_MOVEMENTS_QUERY_PARAMS } from "../api";
import { BatchManualDebtAccountMovementsTable } from "../components/tables/BatchManualDebtAccountMovementsTable";
import { CommissionsBatchStep } from "../enums";

export const CommissionsBatchManualDebtAccountMovementsContainer = () => {
  const { t } = useTranslation();

  const { id } = useParams<EntityIdObject>() as { id: string };
  const navigate = useNavigate();

  const searchParams = useFilterSearchParams<ManualDebtAccountMovementsFilterPageRequest>({
    params: ["report"],
    defaultQueryParamsObject: DEFAULT_FILTER_MANUAL_DEBT_ACCOUNT_MOVEMENTS_QUERY_PARAMS,
  });

  const { data, isFetching, isError } = useFilterManualDebtAccountMovements({ id, object: searchParams });

  return (
    <ContentWrapper>
      <DisplayWrapper itemLoaded={!!data} isError={isError}>
        {data ? (
          <>
            <Card
              className="card-box"
              title={
                <BackNavigationArrow>
                  <h2>{t("commissions.batch.titles.manageManualDebtAccountMovements")}</h2>
                  <span className="sub-header-info normal-font-size">
                    {t("commissions.batch.titles.batchDetail", { name: data.batch.name })}
                  </span>
                </BackNavigationArrow>
              }
            >
              <Flex justify="center">
                <Radio.Group
                  size="large"
                  buttonStyle="solid"
                  value={searchParams.report ?? ManualDebtAccountMovementsReport.ASSOCIATED}
                  onChange={(e) =>
                    navigate(
                      {
                        search: URLQuery.searchParamsToString({
                          searchParams: {
                            ...skipInitialFormValues(
                              { report: e.target.value },
                              DEFAULT_FILTER_MANUAL_DEBT_ACCOUNT_MOVEMENTS_QUERY_PARAMS,
                            ),
                            pageIndex: undefined,
                          },
                          append: true,
                        }),
                      },
                      { replace: true },
                    )
                  }
                >
                  <Radio.Button value={ManualDebtAccountMovementsReport.ASSOCIATED}>
                    {t("commissions.batch.enums.manualDebtAccountMovementsReport.ASSOCIATED")}
                  </Radio.Button>

                  {data.batch.step !== CommissionsBatchStep.FINISH && (
                    <Radio.Button value={ManualDebtAccountMovementsReport.DISASSOCIATED}>
                      {t("commissions.batch.enums.manualDebtAccountMovementsReport.DISASSOCIATED")}
                    </Radio.Button>
                  )}
                </Radio.Group>
              </Flex>
            </Card>

            <Card className="card-box">
              <BatchManualDebtAccountMovementsTable movementsPage={data} loading={isFetching} />
            </Card>
          </>
        ) : undefined}
      </DisplayWrapper>
    </ContentWrapper>
  );
};
